var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFillMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.26667 2 2 8.28 2 16C2 23.72 8.26667 30 16 30C23.7333 30 30 23.7333 30 16C30 8.26667 23.7333 2 16 2ZM13.6667 23C13.6667 23.3067 13.5467 23.6 13.32 23.8267C13.0933 24.0533 12.8 24.1733 12.4933 24.1733H9C8.69333 24.1733 8.4 24.0533 8.17333 23.8267C7.94667 23.6 7.82667 23.3067 7.82667 23V16C7.82667 15.6933 7.94667 15.4 8.17333 15.1733C8.4 14.9467 8.69333 14.8267 9 14.8267H12.4933C12.8 14.8267 13.0933 14.9467 13.32 15.1733C13.5467 15.4 13.6667 15.6933 13.6667 16V23ZM24.16 18.3333C24.16 18.64 24.04 18.9333 23.8133 19.16C23.5867 19.3867 23.2933 19.5067 22.9867 19.5067H17.1467V21.84H20.0667V23.0133H14.8133V21.84H15.9867V19.5067H14.8133V18.3333H22.9733V10.1733H10.16V13.6667H8.98667V10.1733C8.98667 9.86667 9.10667 9.57333 9.33333 9.34667C9.56 9.12 9.85333 9 10.16 9H22.9867C23.2933 9 23.5867 9.12 23.8133 9.34667C24.04 9.57333 24.16 9.86667 24.16 10.1733V18.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFillMonitor);
export default __webpack_public_path__ + "static/media/ic-fill-monitor.09f4342bf561256c6c8424f524450f4c.svg";
export { ForwardRef as ReactComponent };